export default __webpack_public_path__ + "static/media/metaverse-map.40964a03.png";